<app-header></app-header>
<!-- ======= Hero Section ======= -->
<section id="hero" class="d-flex flex-column justify-content-end align-items-center">
    <div id="heroCarousel" class="container carousel carousel-fade" data-ride="carousel">

        <!-- Titulo -->
        <div class="carousel-item active">
            <div class="carousel-container" style="height: 100%;">
                <h2 class="mt-4 animate__animated animate__faster animate__fadeInDown" style="margin-bottom: 0px;">
                    Menu
                </h2>

                <!-- ======= Menu Section ======= -->
                <section id="features" class="features" style="padding: 2rem 0px;">
                    <div class="container">

                        <app-loader *ngIf="isLoading"></app-loader>

                        <ul class="nav nav-tabs" *ngIf="!isLoading">
                            <li *ngIf="!isAuthenticated" class="nav-item col-sm-12 col-md-12 col-lg-6 mb-2" data-aos="zoom-in" data-aos-delay="100">
                                <a class="nav-link" [routerLink]="['/register']">
                                    <i class="ri-user-add-line"></i> &nbsp;
                                    <h4 class="item-menu">Registrarse</h4>
                                </a>
                            </li>
                            <li *ngIf="!isAuthenticated" class="nav-item col-sm-12 col-md-12 col-lg-6 mb-2" data-aos="zoom-in" data-aos-delay="100">
                                <a class="nav-link" [routerLink]="['/login']">
                                    <i class="ri-login-box-line"></i> &nbsp;
                                    <h4 class="item-menu">Iniciar Sesión</h4>
                                </a>
                            </li>
                            <li *ngIf="isAuthenticated" class="nav-item col-sm-12 col-md-12 col-lg-6 mb-2" data-aos="zoom-in" data-aos-delay="100">
                                <a class="nav-link" [routerLink]="['/quinielas']">
                                    <i class="ri-football-line"></i> &nbsp;
                                    <h4 class="item-menu">Administrar mis Quinielas<br><small>Crear una nueva Quiniela</small></h4>
                                </a>
                            </li>
                            <li class="nav-item col-sm-12 col-md-12 col-lg-6 mb-2" data-aos="zoom-in" data-aos-delay="100">
                                <a class="nav-link" [routerLink]="['/faq/info']">
                                    <i class="ri-questionnaire-fill"></i> &nbsp;
                                    <h4 class="item-menu">Preguntas Frecuentes<br><small>Fequently asked questions (FAQ)</small></h4>
                                </a>
                            </li>
                            <li class="nav-item col-sm-12 col-md-12 col-lg-6 mb-2" data-aos="zoom-in" data-aos-delay="100">
                                <a class="nav-link" [routerLink]="['/report/bug']">
                                    <i class="ri-phone-line"></i> &nbsp;
                                    <h4 class="item-menu">Reportar Problema<br><small>Contáctanos</small></h4>
                                </a>
                            </li>
                            <li *ngIf="isAuthenticated" class="nav-item col-sm-12 col-md-12 col-lg-6 mb-2" data-aos="zoom-in" data-aos-delay="100">
                                <a class="nav-link" (click)="logout()" href="">
                                    <i class="ri-logout-box-r-line"></i> &nbsp;
                                    <h4 class="item-menu">Cerrar sesión</h4>
                                </a>
                            </li>
                        </ul>

                    </div>
                </section>
                <!-- End Menu Section -->

                <style>
                    .nav-link {
                        background: white;
                    }
                </style>

            </div>
        </div>
    </div>



    <svg class="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28 " preserveAspectRatio="none">
        <defs>
            <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="wave1">
            <use xlink:href="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
        </g>
        <g class="wave2">
            <use xlink:href="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
        </g>
        <g class="wave3">
            <use xlink:href="#wave-path" x="50" y="9" fill="#fff" />
        </g>
    </svg>


</section>
<!-- End Hero -->